module.exports = "https://www.gc-pro.gnp.com.mx/b8bb6368da98e5bb1caa848c706b4078.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon-pagar.svg
// module id = 8128
// module chunks = 0